import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createPayment,
  deletePayment,
  getPayment,
  updatePayment,
} from "libs/api/payment";

// Payment Thunk
export const getPaymentThunk = createAsyncThunk(
  "payment/get",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getPayment(pathname, queryParams);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Create Payment Thunk
export const createPaymentThunk = createAsyncThunk(
  "payment/create",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body, accessToken }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await createPayment(pathname, body, accessToken);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Update Payment Thunk
export const updatePaymentThunk = createAsyncThunk(
  "payment/update",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body, accessToken }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updatePayment(pathname, body, accessToken);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Delete Payment Thunk
export const deletePaymentThunk = createAsyncThunk(
  "payment/delete",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deletePayment(pathname);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);
